import { useEffect, useState } from 'react';
import { listJobTypes, listZones, type JobType, type Zone } from '../reference-data/reference-data.api';

export type JobCataloguesState = { status: 'loading' } | { status: 'loaded'; jobTypes: JobType[]; zones: Zone[] } | { status: 'error' };

/** The job-type and zone selects the intake form fills — active-only, fetched once (CLAUDE.md's small-fixed-catalogue exception to server-side paging). */
export function useJobCatalogues(): JobCataloguesState {
  const [state, setState] = useState<JobCataloguesState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    Promise.all([listJobTypes(), listZones()])
      .then(([jobTypes, zones]) => {
        if (!cancelled) setState({ status: 'loaded', jobTypes: jobTypes.filter((t) => t.isActive), zones: zones.filter((z) => z.isActive) });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
